module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-100italic.c6c25e3f8e2d27b286473e7bb5114163.woff";